import request from '@/router/axios'

/**
 * 获取滚动图片数据、
 */
export function queryBannerData() {
  return request({
    url: '/presentation/queryBannerData',
    method: 'get'
  })
}

/**
 * 分页查询报表数据
 * @param type 报表类型
 * @param page 分页 信息
 * @return 报表数据
 */
export function queryPageByType(param) {
  return request({
    url: '/presentation/queryPageByType',
    method: 'get',
    params:param
  })
}


// WEBPACK FOOTER //
// ./src/api/presentation.js